import React from "react";
import PropTypes from "prop-types";
import { Label, Button, Icon, Grid } from "semantic-ui-react";
import "./addressDetails.css";
import { countries, states } from "../../constants/appConstants";

const AddressDetails = (props) => {
  const {
    makePrimary,
    address,
    deleteAddressHandler,
    index,
    options = false,
    addHandler,
    cancelHandler,
    changeHandler,
    isDelivery = true,
    isNew = false,
    hasSelect = false,
  } = props;

  if (!address) {
    return null;
  }
  const {
    name,
    street = "",
    street2 = "",
    state = "",
    zip = "",
    country = {},
    city = "",
    isPrimary = false,
    suburb = "",
    salesforceId,
    addressDistance = 0,
  } = address;

  const optionsJXS = (
    <div className="address-options" style={{ paddingBottom: 10 }}>
      {!isPrimary && (
        <Button
          size="mini"
          style={{
            backgroundColor: isDelivery ? "#66cc23" : "#42A5F6",
            color: "#fff",
            padding: 5,
            paddingLeft: 10,
            paddingRight: 10,
          }}
          onClick={() => makePrimary(address.id)}
        >
          Set as default
        </Button>
      )}
      {isDelivery && (
        <Icon
          style={{
            zIndex: 2,
            fontSize: 20,
            position: "absolute",
            bottom: 21,
            right: 30,
            marginRight: 0,
            color: "#ef0e0e",
          }}
          link
          name="trash"
          onClick={() => deleteAddressHandler(index, salesforceId)}
        />
      )}
    </div>
  );

  const addJSX = (
    <Button.Group style={{ width: "100%" }}>
      <Button
        onClick={() => {
          cancelHandler();
        }}
      >
        Cancel
      </Button>
      <Button.Or />
      <Button
        className="active-status"
        onClick={() => {
          addHandler(address, countries, states);
        }}
      >
        Save
      </Button>
    </Button.Group>
  );

  const DefaultAddressRibon = () => {
    return (
      <Label
        style={{
          backgroundColor: isDelivery ? "#66cc23" : "#42A5F6",
          color: "#fff",
        }}
        ribbon
      >
        Default Address
      </Label>
    );
  };

  return (
    <div className="address-detail-card">
      {isPrimary && <DefaultAddressRibon />}
      <div
        className="content"
        style={{
          cursor: !isNew && hasSelect ? "pointer" : "default",
          fontSize: 14,
        }}
        onClick={() => {
          if (!isNew && hasSelect) {
            changeHandler(address);
          }
        }}
      >
        {name && (
          <div style={{ fontWeight: "bolder", paddingBottom: 8 }}>{name}</div>
        )}
        <div>
          {street} {street2}
        </div>
        {suburb && <div>{suburb}</div>}
        <div>
          {city + ", "} {city !== state ? state : city}
        </div>
        <div> {country.name} </div>
        <div> {zip} </div>
        {!isDelivery && addressDistance ? (
          <Grid>
            <Grid.Column width={3}>
              <div className="diamond-background">
                <svg
                  className="arrow-svg"
                  width="15"
                  height="16"
                  viewBox="0 0 15 16"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M14.6016 8.75398C14.9921 8.36346 14.9921 7.73029 14.6016 7.33977L8.23763 0.975807C7.84711 0.585282 7.21394 0.585282 6.82342 0.975807C6.43289 1.36633 6.43289 1.9995 6.82342 2.39002L12.4803 8.04687L6.82342 13.7037C6.43289 14.0943 6.43289 14.7274 6.82342 15.1179C7.21394 15.5085 7.84711 15.5085 8.23763 15.1179L14.6016 8.75398ZM0.638672 9.04688L13.8945 9.04687L13.8945 7.04687L0.638672 7.04688L0.638672 9.04688Z"
                    fill="white"
                  />
                  <line
                    x1="1.63867"
                    y1="7.3103"
                    x2="1.63867"
                    y2="13.2018"
                    stroke="white"
                    stroke-width="2"
                  />
                </svg>
              </div>
            </Grid.Column>
            <Grid.Column width={13} style={{ paddingTop: 23, paddingLeft: 3 }}>
              <span style={{ fontSize: 14, color: "grey" }}>
                {`${addressDistance ? addressDistance : "0"} km away`}
              </span>
            </Grid.Column>
          </Grid>
        ) : null}
      </div>
      <div style={{ marginTop: 30 }}>
        <div className="options">{options && optionsJXS}</div>
      </div>

      {addHandler && addJSX}
    </div>
  );
};

export default AddressDetails;
